/**
 * Shared report footer text.
 *
 * The default is the product-standard value. At app startup the config
 * management system can override it via {@link setReportFooterText} so
 * that customer-specific text appears on all generated reports.
 */

let _footerText = 'Confidential \u2013 For authorized personnel use only.';

/** Returns the current report footer text. */
export const getReportFooterText = (): string => _footerText;

/**
 * Override the report footer text (called once at app init from module config).
 * Pass an empty string to suppress the footer.
 */
export const setReportFooterText = (text: string): void => {
  _footerText = text;
};
